import { useState, useEffect } from "react";
import { useMatch } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { WEB_ROUTES } from "../routes/web-routes";
import { CONTENT_ROUTES } from "../routes/content-routes";
import Header from "../components/header";
import Footer from "../components/footer";
import axios from "axios";
import { Helmet } from "react-helmet";
import { useUtilities } from "../hooks/utilities";

export default function LeadershipSingle() {
  const [leadership, setLeadership] = useState({});
  const singleLeadership = useMatch(WEB_ROUTES.LEADERSHIP + "/:team");
  const [loading, setLoading] = useState({});
  const [page, setPage] = useState({});
  const [pageMedia, setPageMedia] = useState([]);
  const [leadershipMedia, setLeadershipMedia] = useState([]);
  let { getMetaSnippet } = useUtilities();

  useEffect(() => {
    setLoading(true);
    axios
      .get(CONTENT_ROUTES.POST_PAGE("/pages", "leadership"))
      .then((res) => {
        const pageResponse = res.data?.length ? res.data[0] : {};
        setPage(pageResponse);

        //Get page media
        axios
          .get(CONTENT_ROUTES.MEDIA_BY_PAGE(pageResponse?.id))
          .then((res) => {
            setPageMedia(res.data);
          });

        //Get leadership
        axios
          .get(
            CONTENT_ROUTES.LEADERSHIP(
              "?slug=" + singleLeadership?.params?.team,
            ),
          )
          .then((res) => {
            console.log(res.data);
            let teamResponse = res.data?.length ? res.data[0] : {};
            setLeadership(teamResponse);

            //Get leadership media
            let media = [];

            res.data?.map((member, i) => {
              if (member?.featured_media)
                axios
                  .get(CONTENT_ROUTES.MEDIA_BY_ID(member?.featured_media))
                  .then((res) => {
                    media[i] = res.data;
                    setLeadershipMedia((prevState) => [...prevState, media[i]]);
                  });
              return member?.featured_media;
            });
          })
          .catch((err) => {})
          .finally(() => {
            setLoading(false);
          });
      })
      .catch((err) => {})
      .finally(() => {});
  }, [singleLeadership]);

  return (
    <>
      <Helmet>
        <title>{leadership?.title?.rendered + ` - LTWP`}</title>
        <meta
          name="description"
          content={getMetaSnippet(leadership?.content?.rendered)}
        />
      </Helmet>
      <Header />
      <main>
        <section>
          <div className="container mx-auto ">
            <div className="md:flex py-20">
              <div className="w-60 h-60 rounded-full overflow-hidden flex-shrink-0 mx-4 md:mx-0">
                <img
                  src={
                    leadershipMedia?.find(
                      (media) => media.id === leadership?.featured_media,
                    )?.source_url
                  }
                  alt={leadership?.title?.rendered}
                  className="h-full w-full object-cover transition duration-700 ease-in-out transform hover:scale-110"
                />
              </div>

              <div className="text-[#0f243f] md:px-10 px-4 ">
                <div className="w-full text-[#002856] space-y-2 md:px-0 px-4 mb-4">
                  <h1 className="md:text-[50px] text-4xl leading-none md:font-semibold font-bold">
                    {leadership?.title?.rendered}
                  </h1>
                  <h2 className="font-semibold text-[#58b947]">
                    {leadership?.acf?.job_title}
                  </h2>
                </div>
                <div className="max-w-4xl">
                  <div
                    className="prose prose-lg max-w-none mb-5"
                    dangerouslySetInnerHTML={{
                      __html: leadership?.content?.rendered?.replace(
                        /<p.*?>/g,
                        "<p class='mb-5'>",
                      ),
                    }}
                  />
                  {leadership?.content?.rendered && (
                    <>
                      <p className="font-semibold text-[#0070b9] mb-3">
                        Education & Qualifications
                      </p>

                      <div
                        dangerouslySetInnerHTML={{
                          __html: leadership?.acf?.education?.replace(
                            /<p.*?>/g,
                            "<p class='mb-5'>",
                          ),
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
